import { useQuery } from '@tanstack/react-query';

import { campaignsService, CampaignResults } from '@aslanpay/portal-common-lib';

/**
 * A pride's nominees and every nomination written about them. The campaign refuses this until
 * nominations have closed, so it is only asked for once the caller knows they have.
 */
const useFetchCampaignResults = (campaignId: string | undefined, enabled = true) => {
  return useQuery<CampaignResults, Error>(
    ['fetchCampaignResults', campaignId],
    () => campaignsService.fetchCampaignResults(campaignId as string),
    { enabled: enabled && !!campaignId, retry: false }
  );
};

export default useFetchCampaignResults;
